import { DropdownWithLabel } from '@blueprint/dropdown';

const radii = [
    '',
    '0',
    '0.25',
    '0.5',
    '1',
    '3',
    '5',
    '10',
    '15',
    '20',
    '30',
    '40'
];

const radiiOptions = [
    { value: '0', text: 'This area only' },
    { value: '0.25', text: '+ 0.25 miles' },
    { value: '0.5', text: '+ 0.5 miles' },
    { value: '1', text: '+ 1 miles' },
    { value: '3', text: '+ 3 miles' },
    { value: '5', text: '+ 5 miles' },
    { value: '10', text: '+ 10 miles' },
    { value: '15', text: '+ 15 miles' },
    { value: '20', text: '+ 20 miles' },
    { value: '30', text: '+ 30 miles' },
    { value: '40', text: '+ 40 miles' }
];

export type Radius = typeof radii[number];

type SelectRadiusProps = {
    value: Radius;
    onChange: (radius: Radius) => void;
};

export const SelectRadius = ({ value, onChange }: SelectRadiusProps) => {
    const radiusLabel = 'Search radius';

    return (
        <DropdownWithLabel
            id="desktop_radius-filter"
            data-testid="desktop_radius-filter"
            onChange={(e) => {
                onChange(e.target.value);
            }}
            value={value}
            name="radius"
            aria-label="Radius"
            label={radiusLabel}
            hasExtendedHeight
            hasDarkPurpleBorder
            hasNoLeftRightBorder
        >
            {radiiOptions.map((radiiOption, index) => {
                return (
                    <option
                        value={radiiOption.value}
                        key={`quicksearch_radii_${index}`}
                    >
                        {radiiOption.text}
                    </option>
                );
            })}
        </DropdownWithLabel>
    );
};
